<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">Home</a></li>
                            <li><a href="/avaliacao" title="Pages">Testes</a></li>
                            <li>Editar</li>
                        </ul>
                    </section>

                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Editar Testes</b></h2>
                    </div>

                    <b-tabs v-if="dialogEdit">
                        <b-tab title="Dados principais" active>
                            <br />
                            <div class="mold-txt-center">
                                <form-edit v-if="dialogEdit" :id="avaliacaoId" @on-saved="onSaved" @on-back="onBack()" />
                            </div>
                        </b-tab>

                        <b-tab title="Disciplinas">
                            <br />
                            <avaliacao-questao :avaliacao-id="avaliacaoId" />
                        </b-tab>

                        <b-tab title="Cargos">
                            <br />
                            <avaliacao-cargo :avaliacao-id="avaliacaoId" />
                        </b-tab>

                    </b-tabs>

                </div>
            </div>
        </section>


    </main>

</template>
<script>

    import formEdit from './form-edit'
    import avaliacaoQuestao from './avaliacaoquestao'
    import avaliacaoCargo from './avaliacaocargo'

    export default {
        name: 'avaliacao-edit',
        components: { formEdit, avaliacaoQuestao, avaliacaoCargo },
        data: () => ({
            dialogEdit: false,
            avaliacaoId: 0
        }),
        methods: {
            onSaved: function (data) {
                if (data) this.$router.push({ path: '/avaliacao' });
            },
            onBack: function () {
                this.$router.go(-1);
            }
        },
        mounted() {
            this.avaliacaoId = +this.$route.params.id;
            this.dialogEdit = true;
        }
    };
</script>

